export class Buyers {
  constructor (api) {
    this.api = api;
  }

  getSaleProcess = (id) => this.api.get(`/api/buyers/sale_processes/${id}`).then(({ data }) => data);

  getClient = (id) => this.api.get(`/api/buyers/clients/${id}`).then(({ data }) => data);
}
